const GLOBALS = {
  transition_time: '500',
  images: {
    logo: './assets/logo.png',
  },
  links: {
    home: '#',
    github: 'https://github.com/anmolbansal7/cristatus',
    npm: 'https://www.npmjs.com/package/cristatus',
  },
};

export default GLOBALS;
